import axios from '../../plugins/axios.js';

export default{
  async getAuditLogSummary(value) {
    return await axios.get('/api/Auditing?'+value);
  }

}